// Lit le détail d'erreur d'une réponse axios reçue en responseType: 'blob'
export const blobErrorDetail = async (err, fallback) => {
  const data = err?.response?.data;
  try {
    if (data instanceof Blob) {
      const parsed = JSON.parse(await data.text());
      return parsed?.detail || fallback;
    }
    return data?.detail || fallback;
  } catch {
    return fallback;
  }
};
